import { TResponseOrderDetails } from "@/types/projectType";
// import MobileProjectCard from "./MobileProjectCard";
import ProjectTableView from "./ProjectTableView";
import { TCreatorProjectResponseType, TFilterOptions } from "../Projects";
import MobileProjectCard from "./MobileProjectCard";

type OrdersTableProps = {
  data: TCreatorProjectResponseType[];
  filter: TFilterOptions;
  setFilter: React.Dispatch<React.SetStateAction<TFilterOptions>>;
  isFetching: boolean;
  isLoading: boolean;
};

const ProjectsTable = ({
  isFetching,
  isLoading,
  data,
  filter,
}: OrdersTableProps) => {
  return (
    <section>
      {/* Render table view for larger screens */}
      <ProjectTableView
        data={data}
      />

      {/* Render card view for mobile devices */}
      {data?.length > 0 ? (
        <div className="md:hidden">
          {data?.map((item, index) => (
            <MobileProjectCard filter={filter} item={item} key={index} />
          ))}
        </div>
      ) : (
        <div className="md:hidden">
          <p className="md:hidden font-semibold text-center text-gray-600 text-base">
            No data
          </p>
        </div>
      )}
    </section>
  );
};

export default ProjectsTable;
